module.exports = __webpack_public_path__ + "img/7-fourImg.a159e5f2.png";